
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 138.33 138.33"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"CRS_Close_Out","data-name":"CRS Close Out"}},[_c('g',{attrs:{"id":"Stage_-_Close_Out","data-name":"Stage - Close Out"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M97.82 0h-57.3L0 40.52v57.3l40.52 40.51h57.3l40.51-40.51v-57.3zm31.51 94.09l-35.24 35.24H44.25L9 94.09V44.24L44.25 9h49.84l35.24 35.24z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M46.59 14.67L14.67 46.59v45.15l31.92 31.93h45.15l31.93-31.93V46.59L91.74 14.67H46.59z"}})])])])])
          )
        }
      }
    